import { Observable } from 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import  moment from 'moment'

/*
  Generated class for the KumpulKumpulProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class KumpulKumpulProvider {

	constructor(public http: Http) {
		// console.log('Hello KumpulKumpulProvider Provider');
	}

	/**
	 * Function buat dapetin array tanggal dari start date sampai end date. @Levi
	 * @param startDate 
	 * @param endDate 
	 */
	getArrayOfDates(startDate: any, endDate: any): Array<any> {
		// let mindiff = moment().utcOffset();
		let diffdate = moment(endDate).diff(startDate, 'days');
		let arrDate = [];
		for (let i = 0; i <= diffdate; i++) {
			arrDate.push(moment(startDate).add(i, 'days').toISOString());
		}
		return arrDate;
	}

	normalizeShiftTime(shiftStartTime:any,shiftEndTime:any,dateTime:any): Observable<any>{
		
		return new Observable((observer)=>{
			let mindiff = moment().utcOffset();
			let temp = 0;
			let newStart;
			let newEnd

			let hourStart = moment(shiftStartTime).get('hour');
			let minuteStart = moment(shiftStartTime).get('minute');
			temp = 24 + ((hourStart*60 + minuteStart)-mindiff)/60;
			if(temp>24) temp-=24;
			
			if(dateTime==null) newStart = moment().startOf('day').add(mindiff,'minutes').toISOString();
			else newStart = moment(dateTime).startOf('day').add(mindiff,'minutes').toISOString();			
			newStart = moment(newStart).add(temp,'hours').toISOString();

			let hourEnd = moment(shiftEndTime).get('hour');
			let minuteEnd = moment(shiftEndTime).get('minute');
			temp = 24 + ((hourEnd*60 + minuteEnd)-mindiff)/60;
			if(temp>24) temp-=24;

			if(dateTime==null) newEnd = moment().startOf('day').add(mindiff,'minutes').toISOString();
			else newEnd = moment(dateTime).startOf('day').add(mindiff,'minutes').toISOString();
			newEnd = moment(newEnd).add(temp,'hours').toISOString();

			if(newStart>newEnd) newEnd = moment(newEnd).add(1,'day').toISOString();
			let obj = {shiftStartTime:newStart,shiftEndTime:newEnd};
			observer.next(obj);
			observer.complete();
		});
  }
  
  setCookie(cname, cvalue, exdays) {
    return new Promise((resolve, reject) => {
      let d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      let expires = "expires="+d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      resolve(cvalue);
    })
  }
  
  getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  checkCookie(tokenDevices) {
    return new Promise((resolve, reject) => {
      let user = this.getCookie(tokenDevices);
      if (user != "") {
        resolve(true);
      } else {
        resolve(false);
      }
    })
    
  }

}



// WEBPACK FOOTER //
// ./src/providers/kumpul-kumpul/kumpul-kumpul.ts